"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Divider = exports.InfoBox = exports.Section = exports.User = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemAvatar = _interopRequireDefault(require("@material-ui/core/ListItemAvatar"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _ListItemSecondaryAction = _interopRequireDefault(require("@material-ui/core/ListItemSecondaryAction"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faAward = require("@fortawesome/free-solid-svg-icons/faAward");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/jsx-wrap-multilines */
var rankColor = {
  1: '#EEA20F',
  2: '#BDBDBD',
  3: '#BD7649'
};
var DEFAULT_BUTTON_COLOR = '#2697FF';
var useStylesUser = (0, _styles.makeStyles)(() => ({
  root: {
    paddingBottom: '20px',
    paddingTop: '20px'
  },
  userRank: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '20px',
    marginLeft: '2px',
    marginRight: '10px'
  },
  avatar: {
    borderRadius: '5px'
  },
  name: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '75%',
    fontWeight: 500,
    fontSize: '16px'
  },
  secondaryActionContainer: {
    display: 'flex'
  },
  icon: (_ref) => {
    var {
      rank = 1
    } = _ref;
    return {
      marginRight: '25px',
      color: "".concat(rankColor[rank]),
      fontSize: 'xx-large',
      marginTop: '10px'
    };
  },
  pointsContainer: {
    textAlign: 'right'
  },
  points: {
    fontWeight: 500,
    fontSize: '16px'
  },
  lightText: {
    color: '#757575'
  }
}), {
  name: 'Mui-WidgetLeaderboardUser'
});

var User = (_ref2) => {
  var {
    rank,
    avatar,
    name,
    points,
    isCurrent,
    onProfileClick,
    pointsText,
    component = 'li',
    url
  } = _ref2;

  /**
   *  We are passing the rank as props and it will generate the custom classname to be Mui-WidgetLeaderboardUser-icon-1, Mui-WidgetLeaderboardUser-icon-2, Mui-WidgetLeaderboardUser-icon-3.
   *  We want to keep the classnames differently so it will have different color based on the rank
   */
  var classes = useStylesUser({
    rank
  });
  return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
    component: "a",
    href: url,
    className: classes.root,
    button: !isCurrent,
    onClick: onProfileClick,
    ContainerComponent: component
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.userRank
  }, rank), /*#__PURE__*/_react.default.createElement(_ListItemAvatar.default, null, /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    src: avatar,
    variant: "square",
    className: classes.avatar
  })), /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
    primary: /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "h4",
      className: classes.name
    }, name)
  }), /*#__PURE__*/_react.default.createElement(_ListItemSecondaryAction.default, {
    className: classes.secondaryActionContainer
  }, rank <= 3 && /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faAward.faAward,
    className: classes.icon
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.pointsContainer
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h4",
    className: classes.points
  }, points), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.lightText
  }, pointsText))));
};

exports.User = User;
User.propTypes = {
  /**
   * The rank of the user
   */
  rank: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * The avatar of the user
   */
  avatar: _propTypes.default.string,

  /**
   * The name of the user
   */
  name: _propTypes.default.node,

  /**
   * The current points of the user
   */
  points: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Whether the user is currently logged in user or not
   */
  isCurrent: _propTypes.default.bool,

  /**
   * Onclick to go to profile of user
   */
  onProfileClick: _propTypes.default.func,

  /**
   * The units text for points
   */
  pointsText: _propTypes.default.string,

  /**
   * User listItem component type
   */
  component: _propTypes.default.elementType,

  /**
   * Passed as href to listItem
   */
  url: _propTypes.default.string
};
var useStylesSection = (0, _styles.makeStyles)({
  userHeader: {
    marginTop: '34px',
    marginLeft: '18px',
    marginBottom: '13px',
    fontWeight: '500',
    fontSize: '20px',
    lineHeight: '24px'
  }
}, {
  name: 'Mui-WidgetLeaderboardSection'
});

var Section = (_ref3) => {
  var {
    text,
    children,
    component = 'ul'
  } = _ref3;
  var classes = useStylesSection();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.userHeader
  }, text), /*#__PURE__*/_react.default.createElement(_Divider.default, null), /*#__PURE__*/_react.default.createElement(_List.default, {
    component: component,
    disablePadding: true
  }, children));
};

exports.Section = Section;
Section.propTypes = {
  /**
   * The header for the section
   */
  text: _propTypes.default.string.isRequired,

  /**
   * The Users to be displayed inside section
   */
  children: _propTypes.default.element,

  /**
   * Section list component type
   */
  component: _propTypes.default.elementType
};
var useStylesInfoBox = (0, _styles.makeStyles)({
  footerText: {
    marginBottom: '34px',
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '22px'
  }
}, {
  name: 'Mui-WidgetLeaderboardInfoBox'
});

var InfoBox = (_ref4) => {
  var {
    onClick,
    text,
    buttonText,
    url,
    color = DEFAULT_BUTTON_COLOR
  } = _ref4;
  var classes = useStylesInfoBox();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, text && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.footerText
  }, text), /*#__PURE__*/_react.default.createElement(_Button.default, {
    component: "a",
    href: url,
    variant: "outlined",
    color: "primary",
    onClick: onClick,
    style: {
      borderColor: color,
      color
    }
  }, buttonText));
};

exports.InfoBox = InfoBox;
InfoBox.propTypes = {
  /**
   * The action abutton on Click
   */
  onClick: _propTypes.default.func.isRequired,

  /**
   * The info text
   */
  text: _propTypes.default.string,

  /**
   * The button text
   */
  buttonText: _propTypes.default.string.isRequired,

  /**
   * Passed as href to Button
   */
  url: _propTypes.default.string,

  /**
   * color for the button
   */
  color: _propTypes.default.string
};
var Divider = (0, _styles.withStyles)({
  root: {
    marginLeft: '36px'
  }
}, {
  name: 'Mui-WidgetLeaderboardDivider'
})(_Divider.default);
exports.Divider = Divider;
var useStyles = (0, _styles.makeStyles)({
  container: {
    height: 'inherit',
    width: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    backgroundColor: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: '4px'
  },
  header: {
    marginTop: '24px',
    marginLeft: '18px',
    marginBottom: '13px',
    fontWeight: '500',
    fontSize: '20px',
    lineHeight: '24px'
  },
  footer: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  footerContainer: {
    textAlign: 'center'
  }
}, {
  name: 'Mui-WidgetLeaderboard'
});

var Leaderboard = (_ref5) => {
  var {
    children,
    footer,
    title,
    component = 'ul'
  } = _ref5;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.header
  }, title), /*#__PURE__*/_react.default.createElement(_Divider.default, null), /*#__PURE__*/_react.default.createElement(_List.default, {
    component: component,
    disablePadding: true
  }, children), footer && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.footerContainer
  }, footer)));
};

Leaderboard.propTypes = {
  /**
   * Leaderboard container prop:  The user component or section component as children with data
   */
  children: _propTypes.default.arrayOf(_propTypes.default.node),

  /**
   * Leaderboard container prop: The Footer element (Could be an action button or A info box with a text and button)
   */
  footer: _propTypes.default.node,

  /**
   * Leaderboard container prop: The title of the leaderboard container
   */
  title: _propTypes.default.string.isRequired,

  /**
   * Leaderboard list component type
   */
  component: _propTypes.default.elementType
};
var _default = Leaderboard;
exports.default = _default;